<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section>

        <div class="head">
          <div class="swiper-container banner">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
              <div class="swiper-slide" v-if="datas.focus.length <= 0"><img
                  src="../../static/images/AntiFake03/banner.png"></div>
            </div>
          </div>
          <div class="InquireBox">
            <input v-model="vcode" @keyup.enter="CodeVerify" placeholder="请输入追溯码" />
            <img v-on:click="openScan" class="scan" src="../../static/images/AntiFake03/scan.png">
            <a class="InquireBtn" v-on:click="CodeVerify">查询</a>
          </div>
        </div>

        <div class="box">

          <div v-if="isShow" class="main-title"><img class="main-icon"
              src="../../static/images/AntiFake03/icon01.png">查询结果</div>
          <div v-if="isShow" class="main-txt">{{ msg }}，首次查询时间 {{ datas.scan_first_time }}，这次是第 {{ datas.scan_count }}
            次查询！
          </div>

          <div class="main-title"><img class="main-icon" src="../../static/images/AntiFake03/icon01.png">产品信息</div>
          <div class="main">
            <div class="main-sub-title"><img class="main-sub-icon" src="../../static/images/AntiFake03/icon02.png">产品代码
            </div>
            <div v-if="isShow" class="main-box" v-text="datas.product.production_id"></div>
          </div>
          <div class="main">
            <div class="main-sub-title"><img class="main-sub-icon" src="../../static/images/AntiFake03/icon02.png">产品描述
            </div>
            <div v-if="isShow" class="main-box" v-text="datas.product.introduce"></div>
          </div>

        </div>

        <!-- 提示框 -->
        <section id="MaskedBlock" v-if="hintTxt">
          <i class="Masked"></i>
          <div class="ToolTip">
            <ul>
              <li>{{ datas.business.name }}</li>
              <li class="MaskedMain" v-text="hintTxt"></li>
              <li class="confirm" v-on:click="CloseTip">确定</li>
            </ul>
          </div>
        </section>

      </section>

    </div>
  </div>
</template>

<script>
let self, map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'AntiFake03',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      datas: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      },
      msg: null,
      location: null,
      hintTxt: null,
      isShow: false,
      ModulList: [{
        id: "business-box",
        name: "商户"
      }, {
        id: "trace-box",
        name: "溯源"
      }, {
        id: "video-box",
        name: "视频"
      }, {
        id: "ref-box",
        name: "推荐"
      }, {
        id: "menu-box",
        name: "菜单"
      }]
    }
  },
  created() {
    self = this;
    self.getWXInfo();

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated() {
    new Swiper('.banner', {
      autoplay: {
        delay: 5000
      },
      autoHeight: true, //高度随内容变化
    })
  },
  methods: {
    getWXInfo: function () {
      $.ajax({
        type: "post",
        url: "https://sale.oid.plus/v1/wechat-public/js-ticket",
        dataType: 'json',
        data: {
          url: window.location.href,
          syid: "100010034"
        },
        success: function (res) {
          if (res.code == 200) {
            wx.config({
              // debug: true,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: ['scanQRCode']
            });
          }
        }
      });
    },
    openScan: function () {
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            self.vcode = res.resultStr;
            self.CodeVerify();
          }
        });
      });
    },
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
          console.log(datas)
          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {

          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点

          self.msg = "你所查询的是 " + datas.business.name + " 产品"
          if (datas.first_antifake_msg) {
            self.msg = datas.first_antifake_msg;
          }

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);

            if (datas.business.customize_data) {
              for (let i in datas.business.customize_data) {
                if (datas.business.customize_data[i].key == "经纬度") {
                  self.location = datas.business.customize_data[i].value;
                }
              }
            }

          }
          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.isShow = true;

            //针对某个企业做跳转
            if (self.datas.scan_count <= 1 && self.datas.business.rootid == "100010028") {
              self.$router.push({ path: "/AntiFake04" });
            }

          } else {
            self.isShow = false;
          }
        }).catch(function (error) {
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
        })
    },
    CloseTip() {
      self.hintTxt = null;
    }
  }
}
</script>

<style scoped>
.banner img {
  width: 100%;
  display: block;
}

.head {
  position: relative;
}

.InquireBox {
  position: absolute;
  bottom: 10px;
  left: 15px;
  right: 15px;
  padding: 10px;
  border-radius: 5px;
  background-color: #FFF;
  z-index: 999;
}

.InquireBox input {
  height: 30px;
  padding: 0 5px;
  font-size: 16px;
  border: none;
  width: calc(100% - 130px);
}

.scan {
  height: 40px;
  right: 80px;
  top: 5px;
  position: absolute;
  z-index: 99;
}

.InquireBtn {
  color: #FFF;
  width: 65px;
  text-align: center;
  line-height: 40px;
  display: table;
  position: absolute;
  right: 10px;
  top: 5px;
  border-radius: 3px;
  background-color: #48a3fe;
}

.box {
  padding: 10px 20px;
}

.main {
  overflow: hidden;
  border-bottom: 1px solid #ddd;
}

.main-title,
.main-sub-title {
  font-weight: bold;
  padding: 10px 0;
  padding-left: 35px;
  position: relative;
}

.main-sub-title {
  float: left;
  font-size: 15px;
  padding-left: 37px;
  width: 73px;
}

.main-txt {
  padding: 0 10px;
  margin-bottom: 10px;
}

.main-box {
  float: left;
  line-height: 40px;
  font-weight: bold;
  color: #666;
  width: calc(100% - 110px);
}

.main-icon {
  position: absolute;
  width: 30px;
  left: 0;
  top: calc(50% - 15px);
}

.main-sub-icon {
  position: absolute;
  top: calc(50% - 10px);
  left: 10px;
  width: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/AntiFake03.vue